/**
 * @function Linkobject
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * !!! VERALTET !!!
 * TODO: Löschen nach der Migration
 * Erzeugt Linkobjekte für die Kachelseite zur Navigation zwischen SCOs
 * 
 */

angular.module('v3sWbtPlayerApp').directive('v3sLinkobject', ["v3sWbtDataService", "v3sNavigationService", "v3sContentMediaPath", function (v3sWbtDataService, v3sNavigationService, v3sContentMediaPath) {
    return {
        restrict: 'E',
        scope: {
            v3sUrl: '@',
            v3sMode: '@',
            v3sTitle: '@',
            v3sImageActive: '@',
            v3sImageSelected: '@'
        },
        link: function (scope, element, attrs) {
            var wbt = v3sWbtDataService.getWbt();
            var item = wbt.getItem(scope.v3sUrl);

            var imageActive = !!scope.v3sImageActive ? (v3sContentMediaPath + scope.v3sImageActive) : "";
            var imageSelected = !!scope.v3sImageSelected ? (v3sContentMediaPath + scope.v3sImageSelected) : "";
            var completed = false;

            if (!!item) {
                element.on('click', function () {
                    v3sNavigationService.goTo(v3sNavigationService.getPageState(item));
                });

                completed = item.getSco().getStatus() == "completed";
            }

            if (completed && !!imageSelected) {
                element.css('backgroundImage', 'url(' + imageSelected + ')');
            } else {
                if (!!imageActive) element.css('backgroundImage', 'url(' + imageActive + ')');
            }

        }
    }
}]);
